<template>
  <div id="agency_recharge" >
    <van-nav-bar :title="$t('title.agency_recharge')" placeholder fixed safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <!--  列表    -->
      <van-col span="24" class="agency_recharge_list">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
        >
          <van-cell v-for="(item,i) in list" :key="i" @click="Jump_intercept(item)" class="agency_recharge_list_cell">
            <van-col span="24" >
              <van-col span="5" class="agency_recharge_list_cell_img">
                <van-image
                    width="12vw"
                    height="12vw"
                    fit="cover"
                    round
                    :src="item.avatar"
                />
              </van-col>
              <van-col span="19">
                <van-col span="24" class="agency_recharge_list_cell_name">
                  <span>{{ item.user_nickname }}</span>
                  <img src="../assets/img/official_auth.png" v-if="item.is_auth"/>
                </van-col>
                <van-col span="24" class="agency_recharge_list_cell_id">ID: {{ item.uid }}</van-col>
              </van-col>
            </van-col>

            <van-col span="24" class="agency_recharge_list_cell_sum" v-if="item.is_official == 0">
              <van-col span="24" class="agency_recharge_list_cell_sum_coin" v-if="item.consumption_coin">
                <img src="../assets/img/coin7.png"/>
                <span class="agency_recharge_list_cell_sum_coin_color">{{ item.consumption_coin }}</span>
                <span>{{ $t('column.Coins_for_sale') }}</span>
              </van-col>
              <van-col span="24" class="agency_recharge_list_cell_sum_coin" v-if="item.people_sum">
                <img src="../assets/img/coin8.png"/>
                <span class="agency_recharge_list_cell_sum_coin_color">{{ item.people_sum }}</span>
                <span>{{ $t('column.Users_safely_placed_orders_here') }}</span>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-overlay :show="loading"  class="overlay_loading">
        <van-loading type="spinner"/>
      </van-overlay>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import { Toast } from 'vant'

export default {
  data:function() {
    return {
      list: [],
      loading: false,
      finished: false
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    onClickLeft() {
      // 拦截关闭h5
      window.location.href="bogolive://exit"
    },
    Jump_intercept(item) {
      // 拦截返回app
      window.location.href="live://live?action=recharge&id="+ item.id
    },
    get_list(){
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=pay&act=agency_recharge_list",{ params:{ uid: uid, token: token }}).then(res =>{
        console.log(res)
        if(res.data.status===1){
          this.list = res.data.data
          this.finished = true
          this.loading = false
        }else{
          // 加载状态结束
          this.loading = false
          // 数据全部加载完成
          this.finished = true
          Toast.fail(res.data.error);
        }
      })
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/agency_recharge.vue